import { Presentation } from './task_template_topology_answer_presentation';

export class TaskAnswer {
  valuetype:string=""
  value:string=""
  source:string="parts"
  presentations: Presentation[]=[new Presentation()]

}
